import React from 'react';
import { environmentService } from '../../services/environmentService';
import styles from './EnvironmentBanner.module.css';

export function EnvironmentBanner() {
  const config = environmentService.getConfig();

  if (config.isProduction && !config.developerModeEnabled) {
    return null;
  }

  const envClass = styles[config.env] || styles.development;

  return (
    <div className={`${styles.banner} ${envClass}`}>
      <span className={styles.icon}>🔧</span>
      <div className={styles.label}>
        <span>{environmentService.getEnvironmentLabel()} Environment</span>
        {config.developerModeEnabled && (
          <span className={styles.badge}>Developer Mode</span>
        )}
      </div>
    </div>
  );
}
